import Service, { inject as service } from '@ember/service';

export default class DeviceCommands extends Service {
  @service api;
  @service shData;
  @service store;

  update(device, {
    niceName
  }) {
    return this.api.put(`devices/${device.id}`, {
      jsonData: {
        niceName,
      },
    });
  }
}
